import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import { toast } from 'react-toastify';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import Loading from '~/Components/Loading';
import { gerarRelatorioDigitalizacao } from '~/Services/Relatorios/DigitalizacaoService';
import { filtrosSchema } from './validationSchema';
import PainelFiltros from './components/PainelFiltros';
import TabelaResultado from './components/TabelaResultado';
import BotoesAcao from './components/BotoesAcao';

const INITIAL_VALUES = {
  dataInicio: '',
  dataFim: '',
  ordenacao: 'nome',
  detalhe: false,
};

const RelDigitalizacaoPage = () => {
  const [linhas, setLinhas] = useState(null);
  const [meta, setMeta] = useState(null);
  // detalhe usado no grid reflete o último submit, não o checkbox atual
  // (evita colunas trocadas ao mexer no checkbox sem regerar).
  const [detalheResultado, setDetalheResultado] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleGerar = async (values, { setSubmitting }) => {
    setLoading(true);
    setLinhas(null);

    const payload = {
      data_inicio: values.dataInicio,
      data_fim: values.dataFim,
      ordenacao: values.ordenacao,
      detalhe: values.detalhe,
    };

    try {
      const data = await gerarRelatorioDigitalizacao(payload);
      setLinhas(data.linhas || []);
      setMeta(data.meta || null);
      setDetalheResultado(!!values.detalhe);

      if (!data.linhas || data.linhas.length === 0) {
        toast.info('Nenhum resultado encontrado.');
      }
    } catch (err) {
      const mensagem = err && err.message ? err.message : 'Erro ao gerar relatório.';
      toast.error(mensagem);
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  const handleLimpar = (resetForm) => {
    setLinhas(null);
    setMeta(null);
    setDetalheResultado(false);
    resetForm();
  };

  return (
    <Container fluid className="px-3 py-3">
      <HeaderAzul title="Relatório de Digitalizações" />

      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={filtrosSchema}
        onSubmit={handleGerar}
      >
        {({ values, errors, touched, setFieldValue, isSubmitting, submitForm, resetForm }) => (
          <Form>
            <PainelFiltros
              values={values}
              errors={errors}
              touched={touched}
              setFieldValue={setFieldValue}
            />

            <BotoesAcao
              onGerar={submitForm}
              onLimpar={() => handleLimpar(resetForm)}
              loading={loading || isSubmitting}
              temResultado={!!(linhas && linhas.length > 0)}
              linhas={linhas}
              detalhe={detalheResultado}
              dataInicio={values.dataInicio}
              dataFim={values.dataFim}
            />

            {loading && <Loading label="Gerando relatório..." />}

            {!loading && linhas && (
              <TabelaResultado linhas={linhas} detalhe={detalheResultado} meta={meta} />
            )}
          </Form>
        )}
      </Formik>
    </Container>
  );
};

export default RelDigitalizacaoPage;
